import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded font-medium leading-none whitespace-nowrap',
  {
    variants: {
      variant: {
        default: 'bg-muted text-muted-foreground',
        outline: 'border border-border text-muted-foreground',
        primary: 'bg-accent text-accent-foreground',
        success: 'bg-success/15 text-success',
        warning: 'bg-warning/15 text-warning',
        danger: 'bg-danger/15 text-danger',
      },
      size: {
        sm: 'px-1 py-0.5 text-[10px]',
        default: 'px-1.5 py-0.5 text-[11px]',
      },
    },
    defaultVariants: { variant: 'default', size: 'default' },
  },
)

export function Badge({
  className,
  variant,
  size,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badgeVariants>) {
  return <span className={cn(badgeVariants({ variant, size }), className)} {...props} />
}

const LANG_CLASS: Record<string, string> = {
  et: 'text-lang-et border-lang-et/40 bg-lang-et/10',
  en: 'text-lang-en border-lang-en/40 bg-lang-en/10',
  fi: 'text-lang-fi border-lang-fi/40 bg-lang-fi/10',
}

/** Language chip, colour-coded consistently across the whole UI. */
export function LangBadge({ lang, className }: { lang: string; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex h-4 min-w-6 items-center justify-center rounded border px-1 text-[10px] font-semibold uppercase leading-none',
        LANG_CLASS[lang] ?? 'border-border bg-muted text-muted-foreground',
        className,
      )}
    >
      {lang || '—'}
    </span>
  )
}
